import { NonCachedSearchType } from 'interfaces'
import { FilterGroupName } from 'results/constants'

export enum FilterSectionId {
  VEHICLE_FITMENT = 'vehicle_fitment',
  CATEGORY = 'category',
  BRAND = 'brand',
  POSITION = 'position',
  ATTRIBUTES = 'attributes',
  AVAILABILITY = 'availability',
  SELLER = 'seller',
}

export const DEFAULT_FILTER_SECTION_ORDER: FilterSectionId[] = [
  FilterSectionId.VEHICLE_FITMENT,
  FilterSectionId.CATEGORY,
  FilterSectionId.BRAND,
  FilterSectionId.POSITION,
  FilterSectionId.ATTRIBUTES,
  FilterSectionId.AVAILABILITY,
  FilterSectionId.SELLER,
]

export const PINNED_FIRST_FILTER_GROUPS: FilterGroupName[] = [
  FilterGroupName.BRANDS,
  FilterGroupName.PART_TYPE,
]

export const FILTER_GROUP_SECTION_MAP: Record<string, FilterSectionId> = {
  GFX: FilterSectionId.VEHICLE_FITMENT,
  [FilterGroupName.LINES]: FilterSectionId.VEHICLE_FITMENT,
  [FilterGroupName.PART_TYPE]: FilterSectionId.CATEGORY,
  [FilterGroupName.BRANDS]: FilterSectionId.BRAND,
  [FilterGroupName.STOCK]: FilterSectionId.AVAILABILITY,
}

export const FILTER_SECTION_ORDER_BY_SEARCH_TYPE: Partial<
  Record<NonCachedSearchType, FilterSectionId[]>
> = {}

export const VEHICLE_FITMENT_SUB_ORDER: Record<string, number> = {
  GFX: 0,
  [FilterGroupName.LINES]: 1,
}

// Checkbox rows are ~44px tall (10px margins + 24px label line-height)
// currently have 7 and a half rows
export const FILTER_OPTIONS_LIST_MAX_HEIGHT = 330
